<template>
<!--<v-card
    color="#006B38FF"
    dark
  >
    <v-card-text>-->
       <v-autocomplete
         v-model="model"
         :items="items"
         :loading="isLoading"
         :search-input.sync="search"
         color="white"
         hide-no-data
         hide-selected
         item-text="Description"
         :placeholder="generatePlaceholders()"
         prepend-icon="mdi-database-search"
         return-object
       ></v-autocomplete>
     <!--</v-card-text>
  </v-card>-->
</template>

<script>
  import { API_BASE_URL } from '../config'
  import debounce from 'debounce'
  import store from '../store'

  export default {
    data: () => ({
      descriptionLimit: 60,
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      placeholder: null
    }),

    methods: {
      getSearch (val) {
        console.log(val)
        // Don't search for less than 3 letters
        if (val.length < 3) return

        this.isLoading = true

        // Lazily load input items
        fetch(API_BASE_URL + '/card/search/' + val)
          .then(res => res.json())
          .then(res => {
            const { count, entries } = res
            this.count = count
            this.entries = entries
          })
          .catch(err => {
            console.log(err)
          })
          .finally(() => (this.isLoading = false))
      },
      generatePlaceholders: function() {
        if (this.placeholder === null) {
          var placeholders = [
            "What's your favorite card?",
            "What's your favorite commander?",
            "Search",
            "What's your favorite artifact?",
            "What's your favorite blue card?",
            "What's your favorite green card?",
            "What's your favorite white card?",
            "What's your favorite black card?",
            "What's your favorite red card?",
            "What's your favorite creature?"
          ]
          this.placeholder = placeholders[Math.floor(Math.random() * 10)]
        }
        return this.placeholder
      }
    },

    computed: {
      fields () {
        if (!this.model) return []

        return Object.keys(this.model).map(key => {
          return {
            key,
            value: this.model[key] || 'n/a',
          }
        })
      },
      items () {
        return this.entries.map(entry => {
          const Description = entry.name.length > this.descriptionLimit
            ? entry.name.slice(0, this.descriptionLimit) + '...'
            : entry.name

          return Object.assign({}, entry, { Description })
        })
      },
    },

    watch: {
      search: function () {
        this.debounceFn()
      },
      model: function () {
        console.log('search selected: ' + this.model.scryfallId)
        store.dispatch('selectCard', {'cardId':this.model.scryfallId, 'refresh':true}, true)
      }
    },
    created: function() {
      this.debounceFn = debounce( () => {
        this.getSearch(this.search)
      }, 300)
    }
  }
</script>
